import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { viewportOnce } from "../motionPresets";

const SectionHeader = ({ eyebrow, title, subtitle, align = "center" }) => {
  const reduced = useReducedMotion();

  const inner = (
    <>
      <motion.p
        className="text-sky-500 text-[11px] sm:text-xs font-semibold uppercase tracking-[0.2em] mb-3"
        initial={reduced ? false : { opacity: 0, y: 10 }}
        whileInView={reduced ? undefined : { opacity: 1, y: 0 }}
        viewport={viewportOnce}
        transition={{ duration: reduced ? 0 : 0.35, ease: [0.22, 1, 0.36, 1] }}
      >
        {eyebrow}
      </motion.p>
      <motion.h2
        className="text-3xl sm:text-4xl font-semibold text-white tracking-tight"
        initial={reduced ? false : { opacity: 0, y: 14 }}
        whileInView={reduced ? undefined : { opacity: 1, y: 0 }}
        viewport={viewportOnce}
        transition={{ duration: reduced ? 0 : 0.42, delay: reduced ? 0 : 0.05, ease: [0.22, 1, 0.36, 1] }}
      >
        {title}
      </motion.h2>
      <motion.div
        className={`mt-4 h-px w-12 bg-gradient-to-r from-sky-400 to-transparent ${
          align === "center" ? "mx-auto" : ""
        }`}
        initial={reduced ? false : { opacity: 0, scaleX: 0.3 }}
        whileInView={reduced ? undefined : { opacity: 1, scaleX: 1 }}
        viewport={viewportOnce}
        transition={{ duration: reduced ? 0 : 0.45, delay: reduced ? 0 : 0.1, ease: [0.22, 1, 0.36, 1] }}
        style={{ originX: align === "center" ? 0.5 : 0 }}
      />
      {subtitle ? (
        <motion.p
          className="mt-5 text-slate-400 text-base leading-relaxed max-w-2xl mx-auto"
          initial={reduced ? false : { opacity: 0, y: 12 }}
          whileInView={reduced ? undefined : { opacity: 1, y: 0 }}
          viewport={viewportOnce}
          transition={{ duration: reduced ? 0 : 0.4, delay: reduced ? 0 : 0.14, ease: [0.22, 1, 0.36, 1] }}
        >
          {subtitle}
        </motion.p>
      ) : null}
    </>
  );

  if (align === "center") {
    return <div className="mb-12 md:mb-16 text-center px-1">{inner}</div>;
  }

  return <div className="mb-10 md:mb-14 px-1">{inner}</div>;
};

export default SectionHeader;
